import { rem } from 'polished';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import mediaqueries from '../../../config/themes/variables/mediaqueries';
import AvatarPerson from '../../core/AvatarPerson';
import Icon from '../../core/Icon';
import { StyledIconCollapse } from '../../core/MyApps/style';
import Notifications from '../../core/Notifications';
import { StyledHeaderBox } from './BoxLogoAvatarStyle';
import OverWriteMyApps from './styleAppsHeader';

// Usuario
export const StyledUser = styled.figure`
  cursor: pointer;
  ${props =>
    !props.userProfileView
      ? `      
      margin-left: ${rem('26px')};
      margin-top: ${rem('-4px')};
      overflow: hidden;
  `
      : `
    margin-left: ${rem('26px')};
  `}
  ${mediaqueries.lessThan('mobile')`
    margin-top: 15px;
    width: 60px;
    height: 50px;
  `};
`;

// Imagen usuario
export const StyledImagen = styled.img`
  border: ${rem('2px')} solid ${props => props.theme.colors.dark};
  border-radius: 50%;
  height: ${rem('42px')};
  width: ${rem('42px')};
`;

export const StyledIconNotification = styled.div`
  /* height: 2rem;
  margin-left: -3.4375rem;
  position: relative;
  z-index: 12; */
  ${mediaqueries.lessThan('desktop')`
    width: ${rem('133px')};
    height: auto;
  `};
  ${mediaqueries.greaterThan('desktop')`
    background-color: ${props => props.theme.colors.light};
    height:${rem('71px')};
    margin-top:${rem('-1px')};
    overflow:hidden;
    position:relative;
    transition: width .5s ease-in-out;
    width:${rem('184px')};
    z-index:12;
  `};
`;

// Caja para logo
export const StyledBoxLogo = styled.div`
  ${mediaqueries.lessThan('desktop')`
    width: ${rem('133px')};
    height: auto;
  `};
  ${mediaqueries.greaterThan('desktop')`
    background-color: ${props => props.theme.colors.light};
    height:${rem('71px')};
    margin-top:${rem('-1px')};
    overflow:hidden;
    position:relative;
    transition: width .5s ease-in-out;
    width:${rem('184px')};
    z-index:12;
  `};
`;

// Logo
export const StyledLogo = styled(Icon)`
  cursor: pointer;
  margin-left: ${rem('86px')};
  width: ${rem('99px')};
  ${mediaqueries.lessThan('mobile')`
    height: ${rem('21px')};
    margin-left: ${props => props.center === true && '20px !important'};
    margin-top: ${props => props.center === true && '10px !important'};
    width: ${rem('70px')};
  `};
  ${mediaqueries.lessThan('desktop')`
    margin-left: ${props => props.center === true && '0px'};
    margin-top: ${props => props.center === true && '10px !important'};
  `};
  ${mediaqueries.greaterThan('desktop')`
    height:${rem('35px')};
    margin-left:${rem('9px')};
    position:relative;
    top:${rem('18px')};
    width:${rem('117px')};
    z-index:12;
  `};
`;

// Zona interior con contenido
export const StyledNav = styled.nav`
  background-color: ${props => props.theme.colors.light};
  border-bottom: ${rem('2px')} solid ${props => props.theme.colors.dark};
  padding-left: ${rem('25px')};
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 30;
  ${mediaqueries.lessThan('mobile')`
    padding-left: ${rem('16px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    padding-left:0;
  `};
`;

// Listado con Buscador, Logo Dashboard, Logo Noticifiaciones, Logo Apps
export const StyledListGeneral = styled.ul`
  align-items: center;
  display: flex;
  margin: 0;
  padding: 0;
  width: 100%;
  z-index: 12;

  ${props =>
    props.active &&
    `
    z-index: 26;
  `};

  ${mediaqueries.greaterThan('desktop')`
    position:relative;
    height:calc(100% + ${rem('1px')});
    top:${rem('-1px')};
    z-index: 12;
  `};
  ${mediaqueries.lessThan('mobile')`
    justify-content: flex-end;
  `};
`;

export const StyledUserList = styled.li`
  margin-left: 22.75rem;
  align-items: center;
  display: inline-flex;
  height: 100%;
  list-style: none;
  margin-left: ${rem('40px')};
  padding-left: 0;
  ${mediaqueries.lessThan('mobile')`
    // margin-left: ${rem('28px')};
    display: flex;
    position: absolute;
    right: 30;
  `};
  ${mediaqueries.lessThan('desktop')`
    // margin-left: ${rem('28px')};
    display: flex;
    position: absolute;
    right: 30;
    z-index: 15;
  `};
  ${mediaqueries.greaterThan('desktop')`
    margin-left: ${rem('380px')};
    position: relative;
  `};
  &:before {
    content: none;
  }

  &:first-child {
    /* Buscador de header */
    margin-left: auto;
    ${mediaqueries.greaterThan('desktop')`
      margin-right:0;
      margin-left:inherit;
      position:absolute;
      right:${rem('264px')};
      top: 0;
      transition: width 0.5s ease-in-out;
      width: ${rem('735px')};
    `};
  }
  &:nth-child(2) {
    /* Darchboard */
    display: none;
  }
  &:nth-child(3) {
    ${mediaqueries.greaterThan('desktop')`
      display:inline-flex;
      // margin-left:auto;
    `};
  }
  /* &:nth-child(3)   Notificaciones */
  /* &:nth-child(4)   Apss  */
  /* &:nth-child(5)   Perfil  */
  &:nth-child(5) {
    display: none;
    ${mediaqueries.greaterThan('desktop')`
      display:inline-flex;
      margin-left:0;
      margin-top:${rem('5px')};
      transition: width .5s ease-in-out;
      width: ${rem('72px')};
    `};
  }
  &:nth-child(2),
  &:nth-child(3),
  &:nth-child(4) {
    /* Corrección centrado vertical iconos */
    > svg {
      ${mediaqueries.greaterThan('desktop')`
        margin-top:${rem('2px')};
      `};
    }
  }
`;

// Elementos del listado
export const StyledElementsList = styled.li`
  align-items: center;
  display: inline-flex;
  height: 100%;
  list-style: none;
  margin-left: ${rem('40px')};
  padding-left: 0;
  position: relative;
  ${mediaqueries.lessThan('mobile')`
    margin-left: ${rem('28px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    margin-left: ${rem('28px')};
  `};
  &:before {
    content: none;
  }

  &:first-child {
    /* Buscador de header */
    margin-left: auto;
    ${mediaqueries.greaterThan('desktop')`
      margin-right:0;
      margin-left:inherit;
      right:${rem('264px')};
      top: 0;
      transition: width 0.5s ease-in-out;
      width: ${rem('735px')};
    `};
  }
  &:nth-child(2) {
    /* Darchboard */
    display: none;
  }
  &:nth-child(3) {
    ${mediaqueries.greaterThan('desktop')`
      display:inline-flex;
      margin-left:auto;
    `};
  }
  /* &:nth-child(3)   Notificaciones */
  /* &:nth-child(4)   Apss  */
  /* &:nth-child(5)   Perfil  */
  &:nth-child(5) {
    display: none;
    ${mediaqueries.greaterThan('desktop')`
      display:inline-flex;
      margin-left:0;
      margin-top:${rem('5px')};
      transition: width .5s ease-in-out;
      width: ${rem('72px')};
    `};
  }
  &:nth-child(2),
  &:nth-child(3),
  &:nth-child(4) {
    /* Corrección centrado vertical iconos */
    > svg {
      ${mediaqueries.greaterThan('desktop')`
        margin-top:${rem('2px')};
      `};
    }
  }
`;

// Header, contenedor total
export const StyledHeader = styled.header`
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome and Opera */
  position: relative;
  z-index: 40;

  ${mediaqueries.lessThan('mobile')`
    padding-top:${rem('49px')};
  `};
  ${mediaqueries.greaterThan('tablet')`
    padding-top:${rem('73px')};    
  `};

  * svg {
    transition: inherit;
  }

  /* props parte avatar y logo que solo aparezcan en home */
  ${props =>
    props.showHeader &&
    css`
      ${StyledHeaderBox} {
        display: flex;
      }
      ${StyledNav} {
        border-bottom: 0;
      }
      ${StyledBoxLogo} {
        ${mediaqueries.greaterThan('desktop')`
          width: 0;
        `};
      }
      ${StyledElementsList}:first-child {
        width: ${rem('910px')};
      }
      ${StyledElementsList}:nth-child(5) {
        width: ${props => (props.userProfileView ? rem('72px') : 0)};
      }
      ${mediaqueries.greaterThan('desktop')`
        border-bottom: ${rem('0px')} solid ${props.theme.colors.dark};
        z-index: 25;
      `};
    `};

  /* props para logo y usuario al hacer scroll */
  ${props =>
    props.fixed &&
    props.showHeader &&
    css`
      ${mediaqueries.greaterThan('desktop')`
        ${StyledBoxLogo} {
          width:${rem('184px')};
        }
        ${StyledNav} {
          border-bottom: ${rem('0px')} solid ${props.theme.colors.dark};
        }
        ${StyledElementsList}:first-child {
          width: ${rem('735px')};
        }
        ${StyledElementsList}:nth-child(5) {
          width: ${rem('72px')};
        }
      `};
    `};

  ${props =>
    props.fixed &&
    css`
      ${StyledIconCollapse} {
        right: ${rem('75px')};
      }
      ${OverWriteMyApps} {
        &:after {
          right: ${rem('73px')};
        }
      }
    `};
`;

// Div interior nav
export const StyledInterior = styled.div`
  align-items: center;
  display: flex;
  height: ${rem('74px')};
  margin: auto;
  max-width: ${rem('1232px')};
  padding-right: ${rem('26px')};
  position: relative;
  width: 100%;
  ${mediaqueries.lessThan('mobile')`
    height: ${rem('71px')};
    padding-right: ${rem('7px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    height: ${rem('71px')};
    width: 100;
    padding-left: 25px;
    &:before {
      background-color: ${props => props.theme.colors.light};
      content: '';
      left:${rem('56px')};
      height:calc(100% + ${rem('1px')});
      position: absolute;
      top: ${rem('-2px')};
      width:${rem('168px')};
      z-index:12;
    }
  `};
`;

// Hamburguesa
export const StyledHamburguer = styled(Icon)`
  left: 0;
  height: ${rem('24px')};
  position: absolute;
  top: ${rem('23px')};
  width: ${rem('24px')};
  ${mediaqueries.lessThan('mobile')`
    height: ${rem('24px')};
    top: ${rem('23px')};
    left: ${rem('9px')};
    width: ${rem('24px')};
  `};
  ${mediaqueries.lessThan('desktop')`
    z-index: 26;
  `};
  ${mediaqueries.greaterThan('desktop')`
    height: ${rem('24px')};
    top: ${rem('23px')};
    width: ${rem('24px')};
    z-index:inherit;
  `};
`;

// Icono Apps Desktop
export const StyledIconAppsDesktop = styled(Icon)`
  display: none;
  ${mediaqueries.greaterThan('desktop')`
    display:block;
  `};
`;

export const StyledBoxPendingNotification = styled(Link)`
  ${props =>
    props.numNotifications > 0 &&
    css`
      animation: fadeIn 5s;
      @keyframes fadeIn {
        0% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }
    `}
  ${props =>
    props.numNotifications === 0 &&
    css`
      animation: fadeOut 5s;
      @keyframes fadeOut {
        0% {
          opacity: 1;
        }
        100% {
          opacity: 0;
        }
      }
    `}
`;

// Icono Campana
export const StyledIconBell = styled(Icon)`
  height: ${rem('36px')};
  width: ${rem('36px')};
  ${mediaqueries.lessThan('mobile')`
    height: ${rem('24px')};
    width: ${rem('24px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    height: ${rem('24px')};
    width: ${rem('24px')};
  `};
`;

export const StyledIconPendingBell = styled(Icon)`
  height: ${rem('20px')};
  width: ${rem('20px')};
  margin-left: -4rem;
  ${mediaqueries.lessThan('mobile')`
    height: ${rem('12px')};
    width: ${rem('12px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    height: ${rem('20px')};
    width: ${rem('20px')};
  `};
  ${mediaqueries.lessThan('desktop')`
    display: none;
  `};
`;

export const StyledPlusMinus = styled(Icon)`
  height: ${rem('32px')};
  width: ${rem('32px')};
  border-radius: 50%;
  background-color: ${props => props.theme.colors.dark};
  fill: ${props => props.theme.colors.light};
  padding: 7px;
  margin-right: 15px;
  ${mediaqueries.lessThan('mobile')`
    height: ${rem('24px')};
    width: ${rem('24px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    height: ${rem('32px')};
    width: ${rem('32px')};
  `};
`;

// Icono User dispositivos
export const StyledIconUser = styled(Icon)`
  ${mediaqueries.lessThan('mobile')`
    height: ${rem('24px')};
    width: ${rem('24px')};
    display:none;
  `};
  ${mediaqueries.greaterThan('desktop')`
    display:none;
  `};
`;

// Icono circulo con numero de notificaciones
export const StyledIconNot = styled(Notifications)`
  left: ${rem('64px')};
  margin-top: ${rem('-34px')};
  position: absolute;
  ${mediaqueries.lessThan('mobile')`
    left: ${rem('128px')} !important;
  `};
  ${mediaqueries.lessThan('desktop')`
    left: ${rem('128px')};
    margin-top: ${rem('-30px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    left: ${rem('64px')};
  `};
`;

export const StyledAvatarPerson = styled(AvatarPerson)`
  font-size: ${rem('21px')};
`;

export const StyledPendingNotifications = styled.div`
  z-index: 14;
  margin-left: -3rem;
  margin-top: -1rem;
  display: flex;
  position: absolute;
  color: ${props => props.theme.colors.primary};
  padding: 5px;
  height: 20px;
  width: 20px;
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.medium};

  ${mediaqueries.lessThan('mobile')`
    display: none;
  `};
  ${mediaqueries.lessThan('desktop')`
    display: none;
  `};
  ${mediaqueries.between('lessDesktop', 'greatherDesktop')`
    display: none;
  `};
`;

export const StyledLinkMobile = styled(Link)`
  z-index: 14;
  ${mediaqueries.lessThan('desktop')`
    justify-content: center;
    display: ${props => (props.show ? 'block' : 'flex')} ; //sticky
    position: ${props => (props.show ? 'relative' : 'absolute')};
    width: 100%;
    z-index: ${props => (props.show ? '1' : '14')};
  `};

  ${mediaqueries.between('lessDesktop', 'greatherDesktop')`
    width: initial;
    position: unset;
    margin-top: -20px;
  `};
`;

export const StyledLinkMobileMenu = styled(Link)`
  z-index: 14;
  ${mediaqueries.lessThan('desktop')`
    justify-content: center;
    display: block;
    position: relative;
    width: 100%;
    z-index: ${props => (props.show ? '1' : '14')};
  `};
  ${mediaqueries.greaterThan('tablet')`
    justify-content: center;
    display: block;
    position: ${props => (props.show ? 'relative' : 'sticky')};
    width: 100%;
    z-index: ${props => (props.show ? '1' : '14')};
  `};
`;

export const StyledButton = styled.button`
  border: 2px solid black;
`;
